import request from '@/utils/request'

/** 获取消息列表 */
export const getNotificationList = data => request({ url: '/Tip.Tip/tip_list', method: 'post', data })
/** 设置消息分配已读 */
export const getSetNotificationAllRead = data => request({ url: 'Tip.Tip/readAllTip', method: 'post', data })
/** 当条消息已读请求 消息中心type=1 */
export const setMsgReaded = data => request({ url: '/Tip.Tip/readTip', method: 'post', data })


// WEBPACK FOOTER //
// ./src/api/notification.js